export default "__VITE_ASSET__2bddb47a__"